export default __webpack_public_path__ + "static/media/259.0db74c22.png";